import axios from "axios";
import {
  BMC_DOCTOR_WP_BASE_URL,
  BMC_WP_MOBILE_API_BASE,
} from "../constants/apiConfig";

// {headers:{'Auth-Key': '6Q8R9SBUCVDXFYGZJ3K4M5P7Q'}}
const axiosInstance: any = axios.create();

function getDoctorWpBaseUrl(): string {
  const brand = (localStorage.getItem("brandName") || "").toLowerCase().trim();
  if (brand === "bmc") {
    return BMC_DOCTOR_WP_BASE_URL;
  }
  return localStorage.getItem("wpBaseUrl") || "";
}

function getDoctorWpBaseUrlForAutocomplet(): string {
  const brand = (localStorage.getItem("brandName") || "").toLowerCase().trim();
  if (brand === "bmc") {
    return BMC_WP_MOBILE_API_BASE;
  }
  return localStorage.getItem("wpBaseUrl") || "";
}

/** BMC WordPress `mobileapi` REST base (`…/wp-json/mobileapi` + path). Used for specialties (no `vblog` for list) and `getdoctorsbyspecialty` when brand is BMC. */
export async function makeRequestForBmcGetAllSpecialties({ path }: any) {
  try {
    const base = BMC_WP_MOBILE_API_BASE.replace(/\/$/, "");
    const suffix = path.startsWith("/") ? path : `/${path}`;
    const response = await axiosInstance.get(base + suffix);
    return response;
  } catch (error) {
    return error;
  }
}

/** Same as makeRequestForWP; for brand BMC uses BMC_DOCTOR_WP_BASE_URL instead of wpBaseUrl. */
export async function makeRequestForDoctorWP({ path }: any) {
  try {
    const wpBaseUrl = getDoctorWpBaseUrlForAutocomplet();
    const response = await axiosInstance.get(wpBaseUrl + path);
    return response;
  } catch (error) {
    return error;
  }
}

export async function makeRequestForWP({ path }: any) {
   
    try {
        let wpBaseUrl = localStorage.getItem('wpBaseUrl');
        const response = await axiosInstance.get(wpBaseUrl+path);
        return response;
    } catch (error) {
        return error;
    }
}

export async function makeRequestForWPPost({ path, body }: any) {
   
    try {
        let wpBaseUrl = localStorage.getItem('wpBaseUrl');
        const response = await axiosInstance.post(wpBaseUrl+path, body);
        return response;
    } catch (error) {
        return error;
    }
}

